import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import { CropperPosition, ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { CommonDialogComponent } from '../../group-sharing/common-dialog/common-dialog.component';
import { GroupSharingService } from '../../group-sharing/group-sharing.service.component';
import { HotToastService } from '@ngneat/hot-toast';
let stream: MediaStream | null;
declare global {
  interface Window {
    saveAs: any;
  }
}
declare var $: any;



@Component({
  selector: 'app-red-carpet',
  templateUrl: './red-carpet.component.html',
  styleUrls: ['./red-carpet.component.css'],
  encapsulation: ViewEncapsulation.None,

})
export class RedCarpetComponent implements OnInit {

  page = 'redcarpet';
  isIOSDeviceVariable: boolean;
  fullname: any;
  firstName: any;
  schedule: any = [];
  event_id: any;
  theaterOpened = false;
  cinejoyFeaturedGuests: any;
  featuredGuestName: any;
  featuredGuestMovie: any;
  previewImagepic = false;
  saveCroppedImage = false;
  img_result = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  lastCropperPosition: CropperPosition;
  lastCroppedImage: any;
  isLoading = true;
  isSlowMotionGraphicsLoading = false;
  openingRemarksSchedule: any;
  timeDifferString: any;
  timeDiff: any;
  isWatchStarted = false;
  imageURL = '';
  userId: any;
  buttonEnable = false;
  premierename: any;
  redCarpetSchedule: any;
  // Image Cropper Component

  // get current timetext of user
  currentTimeText = new Date().getTime();
  endOfFestival: any;
  endOfFestivalAdd10: any;
  featureGuestImage: any;
  photoboothButton = false;

  @ViewChild('imageCropper') imageCropper: ImageCropperComponent;

  // capture image
  captures: any;
  vimeostreamLink: any;
  redCarpetVideo: any;
  videoURL: SafeResourceUrl;
  frame_width: any;
  frame_height: any;
  durationMotiongraphics: any;
  motionGraphics: any;
  first_video: any;
  second_video: any;
  motionGraphicVideo: any;
  groupSharingActive: any;
  groupSharingMeetingId: any;
  groupSharingDetails: any;
  @ViewChild('video') public video: ElementRef;
  @Input() premierDetails: any;
  @ViewChild('canvas') public canvas: ElementRef;

  constructor(private _route: ActivatedRoute,
    private _getData: SpotlightService,
    private domSanitizer: DomSanitizer,
    private location: Location,
    private router: Router,
    private gsService: GroupSharingService,
    private toast: HotToastService) {
    this.event_id = _route.snapshot.params.id;
  }

  ngOnInit(): void {
    $('#myModal2').hide();
    $('#myModal4').hide();
    $('#myModal5').hide();
    $('#myModal3').hide();
    this.isIOSDevice();



    // Update current user time text for every second
    setInterval(() => {
      this.currentTimeText = new Date().getTime();
    }, 1000);
    // initial hide all modal
    this.getPremierInfo();



    // Get event details by eventId
    // this.gsService.subscribeToEventWatchParty(this.event_id)

    // this.gsService.socketObservable.subscribe((res) => {

    //     if (res && res != undefined && Object.keys(res).length != 0) {
    //         this.openSnackBarForParticipantAdded(res)
    //     }
    // })
    this._getData.getUserDetails().toPromise().then((res: any) => {

      this.firstName = (res.firstName).toUpperCase();
      this.fullname = (res.firstName + ' ' + res.lastName).toUpperCase();
      res['userId'] = res.userID ? res.userID : res.userId
      localStorage.setItem('userData', JSON.stringify(res));

    }).catch((err: any) => {

    });


  }

  durationVideoTime(graphicsT: boolean): void {
    this.durationMotiongraphics = graphicsT;
    this.isLoading = true;
    this.startTheaterpagecounter(graphicsT);
  }
  // Open Instruction Modal
  openModal() {
    $(document).click(function () {
      $('#myModal5').show();
    });
  }

  // Open Photobooth Modal
  openPhotoboothModal() {
    this.photoboothButton = false;
    $(document).click(function () {
      $('#myModal5').hide();
      $('#myModal2').show();
    });

  }

  // Open Upload image preview
  openModal4() {
    $(document).click(function () {
      $('#myModal4').show();
    });
  }

  // Navigate to Theater Page


  // Call API
  getPremierInfo(): void {
    let responseData = this.premierDetails
    if (responseData) {
      console.log('datafromparent', responseData)
      this.setPremierDetails(responseData)
    }else{
      this._getData.getPremierdeatails(this.event_id).toPromise().then((responseData: any) => {
        console.log('datafromapi', responseData)
        this.setPremierDetails(responseData)
      }).catch((err) => {
        alert("Error in Fetching Data")
      })
    }
  }


  setPremierDetails(responseData){
    console.log(" this.setPremierDetails function called")
    this.cinejoyFeaturedGuests = responseData?.cinejoyFeaturedGuests;
    this.premierename = responseData?.name.replace(/ /g, '-');
    this.userId = responseData?.user;
    this.featuredGuestName = (responseData?.cinejoyFeaturedGuests[0]?.mainText).toUpperCase();
    this.featuredGuestMovie = responseData?.ShortDescriptive2 ? (responseData?.ShortDescriptive2).toUpperCase() : '';
   this.motionGraphics = responseData.motionGraphic;
    this.first_video = this.motionGraphics[0]?.firstVideo;
    this.second_video = this.motionGraphics[0]?.secondVideo;
    this.motionGraphicVideo = localStorage.getItem("motionGraphics" + this.event_id);
    if (this.motionGraphicVideo === 'done') {
      console.log("in if condition:" +this.motionGraphicVideo)
      this.isSlowMotionGraphicsLoading = false;
      this.isLoading = true;
      setInterval(() => {
        this.isLoading = false
      }, 4000)

    }else {
      console.log("in else condition:" +this.motionGraphicVideo)
      this.isSlowMotionGraphicsLoading = true;
      this.isLoading = true;
      setInterval(() => {
        this.isLoading = false
      }, 4000)
    }
    //this.imageURL = this.cinejoyFeaturedGuests[0]?.img + '?test=test123';
    if (this.cinejoyFeaturedGuests && this.cinejoyFeaturedGuests.length) {
      this.cinejoyFeaturedGuests.sort((a: any, b: any) =>
        a.guestSequence > b.guestSequence
          ? 1
          : b.guestSequence > a.guestSequence
            ? -1
            : 0
      );
      this.cinejoyFeaturedGuests = this.cinejoyFeaturedGuests;
    }

    this.schedule = responseData.cinejoySpotlightsSchedule;
    if (this.schedule && this.schedule.length) {

      // sort Cinejoyspotlight schedule based on scheduletimetext
      this.schedule.sort((a: any, b: any) => {
        a.scheduleTimeText > b.scheduleTimeText
          ? 1
          : b.scheduleTimeText > a.scheduleTimeText
            ? -1
            : 0;
      });


      this.redCarpetSchedule = this.schedule.find(s => s.scheduleMainText === 'Red Carpet');
      this.endOfFestival = this.schedule.find(s => s.scheduleMainText === 'End of Festivities').scheduleTimeText;
      this.endOfFestivalAdd10 = this.endOfFestival + 36000000;  // Add 10
      //



      if (this.currentTimeText < this.redCarpetSchedule.scheduleTimeText || this.redCarpetSchedule.scheduleMainText !== 'Red Carpet' || this.currentTimeText > this.endOfFestivalAdd10) {
        this.router.navigate([`/premiere/more-info/${this.event_id}/${this.premierename}`]);
        // this.router.navigate([`/premierepage/${this.event_id}`])
      }
      this.openingRemarksSchedule = this.schedule.find(s => s.scheduleMainText === 'Opening Remarks');

      this.startTheaterpagecounter();
      if (this.redCarpetSchedule) {
        this.timeDiff =
          (this.redCarpetSchedule.scheduleTimeText - new Date().getTime()) / 1000;
        if (this.timeDiff > 0) {
          const promise = setInterval(() => {
            this.timeDiff -= 1;
            this.timeDifferString = this.secondsToDhms(this.timeDiff);
            if (this.timeDiff === 0) {
              clearInterval(promise);
            }

          }, 1000);
        }
        this.vimeostreamLink = 'https://vimeo.com/event/' + this.redCarpetSchedule.streamingLink.trim() + '/embed?quality=1080p';
        this.redCarpetVideo = this.domSanitizer.bypassSecurityTrustResourceUrl(this.vimeostreamLink);
        this.frame_width = Math.round(window.innerWidth * 0.9);
        this.frame_height = (this.frame_width * 9) / 12;

        if (window.innerWidth > 1200) {
          this.frame_width = Math.round(window.innerWidth * 0.5);
          this.frame_height = (this.frame_width * 9) / 16;
        }
        this.featureGuestImage = this.cinejoyFeaturedGuests[0].img + '?test=test';
      }
    }
  }

  isIOSDevice(): void {
    // this.isIOSDeviceVariable = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    this.isIOSDeviceVariable = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  }
  // Convert scheduleTime to day,hours,minute & second
  secondsToDhms(seconds: any): string {
    seconds = Number(seconds);
    const d = Math.floor(seconds / (3600 * 24));
    const h = Math.floor((seconds % (3600 * 24)) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    return `${d}d:${h}h:${m}m:${s}s`;
  }

  startTheaterpagecounter(graphicsT?: boolean): void {
    const theaterURL = 'cinejoy/premiere/theater/' + this.event_id;
    const interval = setInterval(() => {
      const currentTimeText = new Date().getTime();
      if (graphicsT === true) {
        this.isSlowMotionGraphicsLoading = false;
        setTimeout(() => {
          this.isLoading = false;
        }, 7000);
      }
      if (this.openingRemarksSchedule.scheduleTimeText <= currentTimeText && currentTimeText <= this.endOfFestivalAdd10 && !this.isSlowMotionGraphicsLoading) {
        clearInterval(interval);
        // this.router.navigate([theaterURL]);
      }
    }, 3000);
  }

  // Watch more now button condition
  startWatch(): void {
    const theaterURL = 'cinejoy/premiere/theater/' + this.event_id;
    if (this.redCarpetSchedule.scheduleTimeText <= this.currentTimeText && this.currentTimeText < this.openingRemarksSchedule.scheduleTimeText) {
      this.buttonEnable = true;
      this.isWatchStarted = true;
      this.photoboothButton = true;
    } else if (this.openingRemarksSchedule.scheduleTimeText <= this.currentTimeText && this.currentTimeText <= this.endOfFestivalAdd10) {
      this.buttonEnable = false;
      // this.router.navigate([theaterURL]);
    } else {
      this.buttonEnable = false;
    }
  }


  // get emoji count data from Emoji Component
  parentFunction(data: any) {
    console.warn(data);
  }

  // Upload Image with preview and cropping event
  fileChangeEvent(event: any): void {
    $('#myModal4').show();
    this.imageChangedEvent = event;
    this.previewImagepic = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    const image = new Image();
    image.src = this.croppedImage;
    const c = document.getElementById('capture')! as HTMLCanvasElement;
    const ctx = c.getContext('2d')!;
    ctx.clearRect(0, 0, c.width, c.height);
    const img = document.getElementById('result_image')! as HTMLImageElement;
    ctx.drawImage(image, 0, 0, c.width, c.height);
  }

  previewCroppedImage() {
    this.img_result = true;
    this.saveCroppedImage = true;
    this.imageCropper.crop();
    this.lastCropperPosition = this.getCurrentCropperPosition();
    this.lastCroppedImage = new ElementRef(this.imageCropper.sourceImage.nativeElement);
  }

  getCurrentCropperPosition() {
    return {
      x1: this.imageCropper.cropper.x1,
      x2: this.imageCropper.cropper.x2,
      y1: this.imageCropper.cropper.y1,
      y2: this.imageCropper.cropper.y2
    };

  }

  save() {
    const image = new Image();
    image.src = this.croppedImage;
    const c = document.getElementById('capture')! as HTMLCanvasElement;
    const ctx = c.getContext('2d')!;
    ctx.clearRect(0, 0, c.width, c.height);
    const img = document.getElementById('result_image')! as HTMLImageElement;
    ctx.drawImage(image, 0, 0, c.width, c.height);
    $('#myModal4').fadeOut();
  }

  hideModal() {
    this.photoboothButton = true;
    $(document).click(() => {
      $('#myModal5').hide();
      $('#myModal2').hide();

    });
  }

  hideCaptureModal() {
    stream!.getTracks().forEach(track => track.stop());
    $('#myModal3').fadeOut();
  }
  hideUploadImgModal() {
    $('#myModal4').hide();
  }
  // -----------------------------------------------------------------------------------------------//

  // Capture Image using web cam

  async openModal3() {
    $('#myModal3').show();
    await this.setupDevices();
  }

  async setupDevices() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });
        if (stream) {
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();

        } else {
          alert('You have no output video device');
          $('#myModal3').hide();

        }
      } catch (e) {
        alert(e);
        $('#myModal3').hide();
      }
    }
  }

  capture() {

    this.drawImageToCanvas(this.video.nativeElement);
    // this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));

  }
  setPhoto() {
    const image = new Image();
    image.src = this.captures;
    this.drawImageToCanvas(image);
  }
  drawImageToCanvas(image: any) {
    this.canvas.nativeElement.width = window.innerWidth;
    this.canvas.nativeElement.height = window.innerHeight;
    this.canvas.nativeElement.getContext('2d').drawImage(image, 0, 0, window.innerWidth, window.innerHeight);
    $('#myModal3').fadeOut();
    stream!.getTracks().forEach(track => track.stop());

  }

  // ----------------------------------------//

  // Download Image Preview
  takeshot() {
    if (this.isIOSDeviceVariable) {
      const element = document.querySelector('#wrapper')! as HTMLCanvasElement;
      html2canvas(element, { allowTaint: true, useCORS: true, scrollX: 0, scrollY: 0 })
        .then(canvas => {
          document.getElementById('my-node')!.appendChild(canvas);
          canvas.style.display = 'none';
          const link = document.createElement('a');
          document.body.appendChild(link);
          link.setAttribute('crossOrigin', 'anonymous');
          link.download = 'cinejoy-feature-guest.png';
          link.href = canvas.toDataURL('image/png');

          link.click();
        });
    } else {
      const element = document.querySelector('#wrapper')! as HTMLCanvasElement;
      html2canvas(element, { allowTaint: true, useCORS: true, scrollX: 0, scrollY: 0 })
        .then(canvas => {
          document.getElementById('my-node')!.appendChild(canvas);
          canvas.style.display = 'none';
          const link = document.createElement('a');
          document.body.appendChild(link);
          link.setAttribute('crossOrigin', 'anonymous');
          link.download = 'cinejoy-feature-guest.png';
          link.href = canvas.toDataURL('image/png');

          link.click();
        });
    }
  }

  openSnackBarForParticipantAdded(message) {
    const toastRef = this.toast.show(CommonDialogComponent, {
      data: {
        fact: `You have been invited to ${message.description} by  ${message.hostFirstName}`,
        joinScreen: false
      },
      autoClose: false,
      theme: 'snackbar',
      position: 'top-right',
      duration: 5000,

    });
    toastRef.afterClosed.subscribe((e) => {

      if (e.dismissedByAction) {
        // callback function to accept the request
        this.gsService.joinFromInvite$.next({ eventId: message.eventId, customRoomId: message.customRoomId })
      } else {

        // callback function to reject the request
      }
    });
  }
}
